<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<pre>{{item}}</pre>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 4 ? true : false,
				nav: true,
				responsive: {
					0: {
						items: 1,
					},
					640: {
						items: 2,
					},
					800: {
						items: 3,
					},
					1024: {
						items: 4,
					}
				}
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-default {
		max-height: 300px;
		overflow: hidden;

		.owl-carousel {

			.item {

			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// default.vue?675b1c74